import { USER_LOGIN, USER_UPDATE } from "./action-types";

export const userLogin = (accessToken, currentUser, usuarioId) => ({
  type: USER_LOGIN,
  payload: {
    accessToken,
    currentUser,
    usuarioId, // <- necessário para o reducer
  },
});

export const userUpdater = (currentUser) => ({
  type: USER_UPDATE,
  payload: {
    currentUser
  }
});
